import React from "react";

const MainContainer = ({
  children,
  background="",
  py="",
  px="",
  sm_px="",
  lg_px="",
  flex="",
  main_axis="",
  cross_axis="",
  flex_direction="",
  className="",
}) => {
  return (
    <div
      className={`min-h-screen ${background} ${py} ${px} ${sm_px} ${lg_px} ${flex} ${main_axis} ${cross_axis} ${flex_direction} ${className}`}
    >
      {children}
    </div>
  );
};

export default MainContainer;
